function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable no-unused-vars */
import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import Text from "../Text/Text";
import ExclamationTriangle from "./ExclamationTriangle/ExclamationTriangle";
import SuccessMark from "./SuccessMark/SuccessMark";
import Available from './Available/Available';

const Title = ({
  isAgentAvailable = false,
  hasErrorMark = false,
  hasSuccessMark = false,
  hasNarrowBottom = false,
  hasLargeBottom = false,
  className,
  children,
  ...props
}) => /*#__PURE__*/React.createElement("div", {
  className: className
}, isAgentAvailable && /*#__PURE__*/React.createElement(Available, {
  isAgentAvailable: isAgentAvailable
}), hasErrorMark && /*#__PURE__*/React.createElement(ExclamationTriangle, null), hasSuccessMark && /*#__PURE__*/React.createElement(SuccessMark, null), /*#__PURE__*/React.createElement(Text, _extends({
  fontWeight: 600,
  variant: "h3",
  fontSize: "21px"
}, props), children));

Title.propTypes = {
  isAgentAvailable: PropTypes.bool,
  hasErrorMark: PropTypes.bool,
  hasSuccessMark: PropTypes.bool,
  hasNarrowBottom: PropTypes.bool,
  hasLargeBottom: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.any.isRequired
};
export default styled(Title)`
  margin-bottom: 30px;
  ${props => props.hasNarrowBottom && css`
      margin-bottom: 15px;
    `}
  ${props => props.hasLargeBottom && css`
      margin-bottom: 40px;
    `}
`;